export const generatePreviewFile = async (upload, refetchUploads) => {
    const res = await fetch(upload.thumbnail);

    if (res.status !== 200) {
        // refetch in case tokens are expired
        refetchUploads();
    }

    const data = await res.blob();
    const file = new File([data], upload.originalFilename, {
        type: "image/jpeg"
    });

    return file;
};

export const getUploadPreviewObject = (upload, previewFile) => ({
    id: upload.id,
    aspectRatio: upload.aspectRatio,
    preview: URL.createObjectURL(previewFile),
    thumbnail: upload.thumbnail
});
